var map = {
	"./AD.ico": 41,
	"./AE.ico": 42,
	"./AF.ico": 43,
	"./AG.ico": 44,
	"./AI.ico": 45,
	"./AL.ico": 46,
	"./AM.ico": 47,
	"./AN.ico": 48,
	"./AO.ico": 49,
	"./AQ.ico": 50,
	"./AR.ico": 51,
	"./AS.ico": 52,
	"./AT.ico": 53,
	"./AU.ico": 54,
	"./AW.ico": 55,
	"./AX.ico": 56,
	"./AZ.ico": 57,
	"./BA.ico": 58,
	"./BB.ico": 59,
	"./BD.ico": 60,
	"./BE.ico": 61,
	"./BF.ico": 62,
	"./BG.ico": 63,
	"./BH.ico": 64,
	"./BI.ico": 65,
	"./BJ.ico": 66,
	"./BL.ico": 67,
	"./BM.ico": 68,
	"./BN.ico": 69,
	"./BO.ico": 70,
	"./BR.ico": 71,
	"./BS.ico": 72,
	"./BT.ico": 73,
	"./BW.ico": 74,
	"./BY.ico": 75,
	"./BZ.ico": 76,
	"./CA.ico": 77,
	"./CC.ico": 78,
	"./CD.ico": 79,
	"./CF.ico": 80,
	"./CG.ico": 81,
	"./CH.ico": 82,
	"./CI.ico": 83,
	"./CK.ico": 84,
	"./CL.ico": 85,
	"./CM.ico": 86,
	"./CN.ico": 87,
	"./CO.ico": 88,
	"./CR.ico": 89,
	"./CU.ico": 90,
	"./CV.ico": 91,
	"./CW.ico": 92,
	"./CX.ico": 93,
	"./CY.ico": 94,
	"./CZ.ico": 95,
	"./DE.ico": 96,
	"./DJ.ico": 97,
	"./DK.ico": 98,
	"./DM.ico": 99,
	"./DO.ico": 100,
	"./DZ.ico": 101,
	"./EC.ico": 102,
	"./EE.ico": 103,
	"./EG.ico": 104,
	"./EH.ico": 105,
	"./ER.ico": 106,
	"./ES.ico": 107,
	"./ET.ico": 108,
	"./EU.ico": 109,
	"./FI.ico": 110,
	"./FJ.ico": 111,
	"./FK.ico": 112,
	"./FM.ico": 113,
	"./FO.ico": 114,
	"./FR.ico": 115,
	"./GA.ico": 116,
	"./GB.ico": 117,
	"./GD.ico": 118,
	"./GE.ico": 119,
	"./GG.ico": 120,
	"./GH.ico": 121,
	"./GI.ico": 122,
	"./GL.ico": 123,
	"./GM.ico": 124,
	"./GN.ico": 125,
	"./GQ.ico": 126,
	"./GR.ico": 127,
	"./GS.ico": 128,
	"./GT.ico": 129,
	"./GU.ico": 130,
	"./GW.ico": 131,
	"./GY.ico": 132,
	"./HK.ico": 133,
	"./HN.ico": 134,
	"./HR.ico": 135,
	"./HT.ico": 136,
	"./HU.ico": 137,
	"./IC.ico": 138,
	"./ID.ico": 139,
	"./IE.ico": 140,
	"./IL.ico": 141,
	"./IM.ico": 142,
	"./IN.ico": 143,
	"./IQ.ico": 144,
	"./IR.ico": 145,
	"./IS.ico": 146,
	"./IT.ico": 147,
	"./JE.ico": 148,
	"./JM.ico": 149,
	"./JO.ico": 150,
	"./JP.ico": 151,
	"./KE.ico": 152,
	"./KG.ico": 153,
	"./KH.ico": 154,
	"./KI.ico": 155,
	"./KM.ico": 156,
	"./KN.ico": 157,
	"./KP.ico": 158,
	"./KR.ico": 159,
	"./KW.ico": 160,
	"./KY.ico": 161,
	"./KZ.ico": 162,
	"./LA.ico": 163,
	"./LB.ico": 164,
	"./LC.ico": 165,
	"./LI.ico": 166,
	"./LK.ico": 167,
	"./LR.ico": 168,
	"./LS.ico": 169,
	"./LT.ico": 170,
	"./LU.ico": 171,
	"./LV.ico": 172,
	"./LY.ico": 173,
	"./MA.ico": 174,
	"./MC.ico": 175,
	"./MD.ico": 176,
	"./ME.ico": 177,
	"./MF.ico": 178,
	"./MG.ico": 179,
	"./MH.ico": 180,
	"./MK.ico": 181,
	"./ML.ico": 182,
	"./MM.ico": 183,
	"./MN.ico": 184,
	"./MO.ico": 185,
	"./MP.ico": 186,
	"./MQ.ico": 187,
	"./MR.ico": 188,
	"./MS.ico": 189,
	"./MT.ico": 190,
	"./MU.ico": 191,
	"./MV.ico": 192,
	"./MW.ico": 193,
	"./MX.ico": 194,
	"./MY.ico": 195,
	"./MZ.ico": 196,
	"./NA.ico": 197,
	"./NC.ico": 198,
	"./NE.ico": 199,
	"./NF.ico": 200,
	"./NG.ico": 201,
	"./NI.ico": 202,
	"./NL.ico": 203,
	"./NO.ico": 204,
	"./NP.ico": 205,
	"./NR.ico": 206,
	"./NU.ico": 207,
	"./NZ.ico": 208,
	"./OM.ico": 209,
	"./PA.ico": 210,
	"./PE.ico": 211,
	"./PF.ico": 212,
	"./PG.ico": 213,
	"./PH.ico": 214,
	"./PK.ico": 215,
	"./PL.ico": 216,
	"./PN.ico": 217,
	"./PR.ico": 218,
	"./PS.ico": 219,
	"./PT.ico": 220,
	"./PW.ico": 221,
	"./PY.ico": 222,
	"./QA.ico": 223,
	"./RO.ico": 224,
	"./RS.ico": 225,
	"./RU.ico": 226,
	"./RW.ico": 227,
	"./SA.ico": 228,
	"./SB.ico": 229,
	"./SC.ico": 230,
	"./SD.ico": 231,
	"./SE.ico": 232,
	"./SG.ico": 233,
	"./SH.ico": 234,
	"./SI.ico": 235,
	"./SK.ico": 236,
	"./SL.ico": 237,
	"./SM.ico": 238,
	"./SN.ico": 239,
	"./SO.ico": 240,
	"./SR.ico": 241,
	"./SS.ico": 242,
	"./ST.ico": 243,
	"./SV.ico": 244,
	"./SY.ico": 245,
	"./SZ.ico": 246,
	"./TC.ico": 247,
	"./TD.ico": 248,
	"./TF.ico": 249,
	"./TG.ico": 250,
	"./TH.ico": 251,
	"./TJ.ico": 252,
	"./TK.ico": 253,
	"./TL.ico": 254,
	"./TM.ico": 255,
	"./TN.ico": 256,
	"./TO.ico": 257,
	"./TR.ico": 258,
	"./TT.ico": 259,
	"./TV.ico": 260,
	"./TW.ico": 261,
	"./TZ.ico": 262,
	"./UA.ico": 263,
	"./UG.ico": 264,
	"./US.ico": 265,
	"./UY.ico": 266,
	"./UZ.ico": 267,
	"./VA.ico": 268,
	"./VC.ico": 269,
	"./VE.ico": 270,
	"./VG.ico": 271,
	"./VI.ico": 272,
	"./VN.ico": 273,
	"./VU.ico": 274,
	"./WF.ico": 275,
	"./WS.ico": 276,
	"./YE.ico": 277,
	"./YT.ico": 278,
	"./ZA.ico": 279,
	"./ZM.ico": 280,
	"./ZW.ico": 281,
	"./_abkhazia.ico": 282,
	"./_basque-country.ico": 283,
	"./_british-antarctic-territory.ico": 284,
	"./_commonwealth.ico": 285,
	"./_england.ico": 286,
	"./_gosquared.ico": 287,
	"./_kosovo.ico": 288,
	"./_mars.ico": 289,
	"./_nagorno-karabakh.ico": 290,
	"./_nato.ico": 291,
	"./_northern-cyprus.ico": 292,
	"./_olympics.ico": 27,
	"./_red-cross.ico": 293,
	"./_scotland.ico": 294,
	"./_somaliland.ico": 295,
	"./_south-ossetia.ico": 296,
	"./_united-nations.ico": 297,
	"./_unknown.ico": 298,
	"./_wales.ico": 299
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 40;